import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sc-station-search-dialog',
  templateUrl: './station-search-dialog.component.html',
  styleUrls: ['./station-search-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StationSearchDialogComponent implements OnInit {
  station: any;
  constructor(public dialogRef: MatDialogRef<StationSearchDialogComponent>) {}

  ngOnInit() {}
  selectStation(station) {
    this.station = station;
  }
  clearSearch() {
    this.station = null;
  }
}
